
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-wukong",
      function () {
        return require("private-next-pages/why-wukong/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-wukong"])
      });
    }
  